import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';

function ParkingAtScrollBtn({
  detailsRef,
  highlightsRef,
  locationRef,
  reviewsRef,
  showHighlights,
}) {
  const [activeSection, setActiveSection] = useState('details');

  const handleScroll = (section) => {
    setActiveSection(section);
    switch (section) {
      case 'details':
        detailsRef.current?.scrollIntoView({ behavior: 'smooth' });
        break;
      case 'highlights':
        highlightsRef.current?.scrollIntoView({ behavior: 'smooth' });
        break;
      case 'location':
        locationRef.current?.scrollIntoView({ behavior: 'smooth' });
        break;
      case 'reviews':
        reviewsRef.current?.scrollIntoView({ behavior: 'smooth' });
        break;
      default:
        break;
    }
  };

  return (
    <div className="grid grid-cols-4 border-b md:border-none">
      <button
        onClick={() => handleScroll('details')}
        className={`font-bold text-base md:text-xl md:mt-8 p-2 md:p-4 w-24 md:w-36 text-center rounded-full cursor-pointer bg-white hover:text-primary`}
      >
        Details
      </button>
      {showHighlights && (
        <button
          onClick={() => handleScroll('highlights')}
          className={`font-bold text-base md:text-xl md:mt-8 p-2 md:p-4 w-24 md:w-36 text-center rounded-full cursor-pointer bg-white hover:text-primary`}
        >
          Highlights
        </button>
      )}

      <button
        onClick={() => handleScroll('location')}
        className={`font-bold text-base md:text-xl md:mt-8 p-2 md:p-4 w-24 md:w-36 text-center rounded-full cursor-pointer bg-white hover:text-primary`}
      >
        Location
      </button>
      <button
        onClick={() => handleScroll('reviews')}
        className={`font-bold text-base md:text-xl md:mt-8 p-2 md:p-4 w-24 md:w-36 text-center rounded-full cursor-pointer bg-white hover:text-primary`}
      >
        Reviews
      </button>
    </div>
  );
}

export default observer(ParkingAtScrollBtn);
